import { Reducer } from "redux";

import { GetRoleResponse } from "../models/Api/User";
import { GetRoleDispatchTypes } from "../models/DispatchTypes/User";
import { GetRolesActionDispatchTypes } from "../constants/User";

export const initialState: GetRoleResponse = {
  loading: false,
  response: [ ],
};

const RoleReducer: Reducer<GetRoleResponse, GetRoleDispatchTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GetRolesActionDispatchTypes.GET_ROLES_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetRolesActionDispatchTypes.GET_ROLES_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetRolesActionDispatchTypes.GET_ROLES_RESET: {
          return initialState;
        }
        case GetRolesActionDispatchTypes.GET_ROLES_ERROR: {
          return initialState;
        }
    
  }
  return state;
};

export default RoleReducer;
